import { SpacingToken } from '@optimus-web/common';

export const FILTERS_SPACING: SpacingToken = '300';

export const ACCORDION_HEADER_SPACING: SpacingToken = '300';

export enum ProductCheckListFilterFieldsDataTestId {
    date = 'pclf-date',

    advancedSettings = 'pclf-advanced-filters',
    claimProducts = 'pclf-claimed-products',
    displayedColumns = 'pclf-displayed-columns',

    reservationSection = 'pclf-reservation-section',
    reservationStatus = 'pclf-reservation-status',
    showReservationWithoutProducts = 'pclf-show-reservation-without-products',

    productsSection = 'pclf-product-section',
    productSelectField = 'pclf-product-select-field',
}
